<template>
  <div
    class="card"
    :class="task.category.name === 'Zrobione' ? 'finished-task' : ''"
    @click="handleCardClick"
  >
    <div class="name">{{ task.title }}</div>
    <div class="user">
      {{
        task.employee && task.employee.firstName
          ? `${task.employee.firstName} ${task.employee.lastName}`
          : task.customer && task.customer.id
          ? `${task.customer.firstName} ${task.customer.lastName}`
          : ""
      }}
    </div>
    <div class="footer">
      <img
        v-if="task.priority && task.priority.name === 'Pilne'"
        src="../../icons/dod/important.svg"
        alt=""
      />
      <div>
        <img src="../../icons/dod/read_message.svg" alt="" />
        <span class="ml-2">{{
          task.messages && task.messages.length > 0 ? task.messages.length : 0
        }}</span>
      </div>

      <div class="date" v-if="formatDate && task.dueDate">
        {{ formatDate(task.dueDate) }}
      </div>
    </div>
  </div>
</template>
<script>
import shared from "../../shared";
export default {
  name: "TaskCard",
  emits: ["click"],
  components: {},
  props: {
    task: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    formatDate(date) {
      return shared.dateToDayMonthYearFormat(date);
    },
    handleCardClick() {
      this.$emit("click");
    },
  },
};
</script>
<style scoped>
.card {
  display: flex;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
  border: 0.5px solid var(--granatowy-25, rgba(9, 7, 65, 0.25));
  background: var(--white-white, #fff);
  box-shadow: 0px 4px 15px 0px rgba(96, 108, 128, 0.25);
  margin-bottom: 1rem;
  cursor: pointer;
  height: 136px;
}
.footer {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.name {
  color: var(--gray-800, #1f2633);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.user,
.date {
  color: var(--gray-800, #1f2633);
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 15.6px */
}
.date {
  width: 100%;
  text-align: right;
}
.card:hover {
  background: #f1f1f1;
}
.footer div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.finished-task {
  opacity: 0.5;
}
</style>
